import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTiposRol } from 'services/servicioGet';
import { TipoGenerico } from 'utils/models/types';

interface TiposRolState {
  tiposRol: TipoGenerico[];
  loadingTiposRol: boolean;
  errorTiposRol: string | null;
}

// Estado inicial del slice
const initialState: TiposRolState = {
  tiposRol: [],
  loadingTiposRol: false,
  errorTiposRol: null,
};

// Thunk para obtener los alquileres
export const fetchTiposRol = createAsyncThunk<TipoGenerico[], void, { rejectValue: string }>(
  'fetchTiposRol',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getTiposRol();
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de espectaculos
const tiposRolSlice = createSlice({
  name: 'tiposRol',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTiposRol.pending, state => {
        state.loadingTiposRol = true;
        state.errorTiposRol = null;
      })
      .addCase(fetchTiposRol.fulfilled, (state, action) => {
        state.tiposRol = action.payload;
        state.loadingTiposRol = false;
      })
      .addCase(fetchTiposRol.rejected, (state, action) => {
        state.loadingTiposRol = false;
        state.errorTiposRol = action.payload as string;
      });
  },
});

export default tiposRolSlice.reducer;
